<div class="tw-pl-4 tw-italic" data-cy="signature-request-status">
    <span *ngIf="sending(); else status">
      Sending Signature Request
    </span>
  <ng-template #status>
    <div *ngIf="isPrimary; else secondary">
      {{ primarySignatureStatus }}
      <span *ngIf="primarySignedDate" class="signed-date">({{ primarySignedDate | date }})</span>
    </div>
    <ng-template #secondary>
      {{ signatureStatus }}
      <span *ngIf="signedDate" class="signed-date">({{ signedDate | date }})</span>
    </ng-template>
  </ng-template>
</div>
<button
  [disabled]="signatureRequestSending.sending"
  (click)="sendSignatureRequest()"
  data-cy="send-signature-request-button"
  data-pendo="send-signature-request-button"
  class="send-button"
  mat-button
  color="primary">
  <mat-spinner
    *ngIf="sending(); else text"
    diameter="20">
  </mat-spinner>
  <ng-template #text>
    <span *ngIf="signatureStatus === 'Signature Request Sent'; else first">Send Another Marketplace Signature Request</span>
    <ng-template #first>Send Marketplace Signature Request</ng-template>
  </ng-template>
</button>
